import * as React from 'react';
import Clock from 'react-live-clock';

export default function DigitalClock() {
    return (
        <Clock format={'HH:mm:ss'} ticking={true} timezone={'Europe/Stockholm'} />
    )
}